<div class="mr-4 h-full pt-3">
  <div class="w-full h-[100%] flex flex-col">
    <!-- To show loading message, while http call is in progress -->
    <sp-loading-inprogress *ngIf="httpCallInProgress; else loadingComplete" [showSpinner]="true"></sp-loading-inprogress>
    <ng-template #loadingComplete>
      <ng-container *ngIf="basketDataLoaded && collectionList.length" class="flex flex-row h-full">
        <thehubz-collections-list
          [collectionList]="collectionList"
          [collectionSplitList]="collectionSplitList"
          [configObject]="configObject"
          [basketDataLoaded]="basketDataLoaded"
          (sortPublicCollections)="sortBy($event)"
          (publicCollectionChanged)="publicCollectionChanged($event.action, $event.data)"
          (updatePublishedCollection)="fetchCollections()"
        ></thehubz-collections-list>
      </ng-container>
      <ng-container *ngIf="basketDataLoaded && !collectionList.length" class="pr-3 overflow-hidden !h-40">
        <p i18n>No collection available</p>
      </ng-container>
    </ng-template>
  </div>
</div>
